export default "__VITE_ASSET__BXaF4eij__"